export default {
  title: '下载基础包',
  select: '请选择质量',
  lowQuality: '低质量',
  middleQuality: '中质量',
  highQuality: '高质量',
}
